module.exports = __webpack_public_path__ + "img/44f339244a4cfc6ba421f2040b9eb645.90f9d0e5.png";